import router from '@/router'

export default () => {
  router.addRoute({
    path: '/plaid/oauth-return',
    name: 'plaid-oauth-return',
    component: () => import(/* webpackChunkName: "plaid-oauth-return" */ './plaidOAuthReturn.vue'),
    meta: {
      permissions: {
        roles: ['user'],
        redirectTo: {
          name: 'login'
        }
      }
    }
  })
}
